<template>
  <div class="row" style="height: calc(100vh - 140px)">
    <component v-bind:is="tag"/>
  </div>
</template>
<script>

var view = require('../view.js'),
    viewData = {
      items: null,
      item: null,
    },
    resetData = Object.assign({}, viewData);

export default view(viewData, {
  props: {

  },
  computed: {
    isDetails() {
      return this.$parent.viewParam != null;
    },

    tag() {
      return this.$parent.viewIndex || 'Infothek';
    }
  },
  async mounted() {
    this.$parent.viewTitle = this.$t('Infothek.title');

    console.log('infothek', this.$parent.viewIndex, this.$parent.viewParam);
  },
  methods: {

  }
});
</script>
<style>

</style>
